'use client';

import { useCallback } from 'react';
import type { IdentityState } from '../../core';
import { buildGlobalContext, sendGTMEvent } from '../../core';

export function useGtmAuthEvents(identity?: IdentityState) {
  const fireLogin = useCallback(
    (loginMethod: string, loginIdentity?: IdentityState) => {
      const context = buildGlobalContext(loginIdentity ?? identity);
      sendGTMEvent({
        event: 'login',
        ...context,
        login_method: loginMethod,
        page_type: 'login',
        step_name: 'user-dashboard',
      });
    },
    [identity],
  );

  const fireLogout = useCallback(() => {
    sendGTMEvent({
      event: 'logout',
      user_logged_in: false,
      email_sha: '',
      tel_sha: '',
      login_method: 'unknown',
      user_status: '',
    });
  }, []);

  return { fireLogin, fireLogout };
}
